<script>
  import { router, matchRoute, navigate } from "@bitcashier/shared/router/router.svelte.js";
  import { loadScreen } from "@bitcashier/shared/router/staleChunk.js";
  import { brand } from "../../brands/index.js";
  import Loader from "../ui/Loader.svelte";

  // routes: [{ path, title?, loader?: () => import(...), redirect?: string }]
  // fallback: path to send unmatched URLs to (React had <Route path="*" element={<Navigate to="/">}).
  let { routes, fallback = null } = $props();

  const match = $derived(matchRoute(routes, router.path));

  // React set "{brand} | {page}" per route via react-helmet, so tabs and bookmarks are
  // distinguishable. Without this every page shares one title.
  $effect(() => {
    document.title = match?.route.title ? `${brand.title} | ${match.route.title}` : brand.title;
  });

  // Follow redirect routes, and the catch-all for unknown paths.
  $effect(() => {
    if (match?.route.redirect) navigate(match.route.redirect, { replace: true });
    else if (!match && fallback) navigate(fallback, { replace: true });
  });

  // Lazy-load the matched screen's chunk. Keyed on path so navigation swaps components.
  const loaded = $derived.by(() => {
    if (!match || match.route.redirect || !match.route.loader) return null;
    return loadScreen(match.route.loader);
  });
</script>

{#if !match}
  <Loader />
{:else if match.route.redirect}
  <Loader />
{:else}
  {#await loaded}
    <Loader />
  {:then Screen}
    {#if Screen}
      <Screen params={match.params} title={match.route.title} />
    {/if}
  {:catch err}
    <div class="error-box">Failed to load screen: {err.message}</div>
  {/await}
{/if}
